import { useEffect, useState } from "react";

const useInactivityLogout = ({
  timeout = 7000,
  disabled = false,
}) => {
  const [isInactive, setIsInactive] = useState(false);

  // activity tracking
  useEffect(() => {
    if (disabled || !timeout) return;

    let timeoutId;

    const resetTimer = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setIsInactive(true), timeout);
    };

    const handleActivity = () => resetTimer();

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("click", handleActivity);

    resetTimer();

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("click", handleActivity);
    };
  }, [timeout, disabled]);

  return isInactive;
};

export default useInactivityLogout;
